
const TKC=window.TOKENS_CART_CONFIG||{};
const TK_CUR=TKC.currency||"USD";
/* Pack prices come from the Shopify variants through Liquid, so Markets
   currency conversion and any price edit in admin flow straight through. */
const TK_KIND=document.body.dataset.kind||"";
const TK_PACKS=((TKC.products||{})[TK_KIND]||{}).packs||{};
const packPrice=(mode,q)=>{const p=TK_PACKS[q];if(!p)return 0;
  const c=(mode==="sub"&&p.subPrice!=null)?p.subPrice:p.price; return c/100;};
const packCadence=q=>(TK_PACKS[q]||{}).cadence||"";
let mode="sub";
const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
const money=n=>{
  try{ return new Intl.NumberFormat(document.documentElement.lang||"en",
    {style:"currency",currency:TK_CUR,
     minimumFractionDigits:Number.isInteger(n)?0:2,maximumFractionDigits:2}).format(n);
  }catch(e){ return "$"+(Number.isInteger(n)?n:n.toFixed(2)); }
};
const unit=($(".buy")||{dataset:{}}).dataset.unit||"night";
function render(){
  if(!$('input[name="bundle"]'))return;
  [1,2,3].forEach(q=>{
    const pk=TK_PACKS[q];
    const total=packPrice(mode,q), once=packPrice("once",q);
    const per=total?Math.round(total/(q*30)*100)/100:0;
    const pEl=$(`[data-price="${q}"]`), nEl=$(`[data-night="${q}"]`), cEl=$(`[data-cadence="${q}"]`);
    if(pEl) pEl.innerHTML=money(total)+(mode==="sub"&&once>total?` <s>${money(once)}</s>`:"");
    if(nEl) nEl.textContent=`${money(per)} a ${unit}`;
    if(cEl) cEl.textContent=mode==="sub"
      ? (packCadence(q)||(q===1?"Ships every month":`Ships every ${q} months`))
      : `${money(once)} per pack, one delivery`;
    const row=pEl&&pEl.closest("label"); if(row&&pk) row.classList.toggle("sold-out",pk.available===false);
  });
  const q=+$('input[name="bundle"]:checked').value, total=packPrice(mode,q);
  $("#atc").textContent=`Add to cart, ${money(total)}`;
  $("#subnote").hidden=mode!=="sub";
  const sl=$("[data-sticky-line]"); if(sl) sl.textContent=`${q*30} ${unit}s, ${money(total)}`;
}
$$(".mode button").forEach(b=>b.addEventListener("click",()=>{mode=b.dataset.mode;$$(".mode button").forEach(x=>x.setAttribute("aria-pressed",x===b));render();}));
$$('input[name="bundle"]').forEach(i=>i.addEventListener("change",render));
$$(".thumb").forEach(t=>t.addEventListener("click",()=>{$$(".thumb").forEach(x=>x.setAttribute("aria-selected",x===t));$$(".frame").forEach(f=>f.classList.toggle("on",f.id===t.getAttribute("aria-controls")));}));
$$("[data-cart]").forEach(b=>b.addEventListener("click",e=>{e.preventDefault();TK.open();}));
$$("[data-add]").forEach(b=>b.addEventListener("click",async e=>{
  e.preventDefault(); const kind=document.body.dataset.kind; if(!kind)return;
  const q=+(($('input[name="bundle"]:checked')||{}).value||1);
  const main=$("#atc"); const label=main?main.textContent:"";
  $$("[data-add]").forEach(x=>x.classList.add("done"));
  await TK.add(kind,q,mode);
  if(main){main.textContent="Added";setTimeout(()=>{$$("[data-add]").forEach(x=>x.classList.remove("done"));render();},1400);}
}));
const sticky=$("#sticky"), atc=$("#atc");
if(sticky&&atc) new IntersectionObserver(([e])=>{const s=!e.isIntersecting&&e.boundingClientRect.top<0;sticky.classList.toggle("show",s);sticky.setAttribute("aria-hidden",!s);}).observe(atc);
const rot=$(".announce.rot");
if(rot){const items=$$(".rot-item",rot),dots=$$(".rot-dots button",rot);let i=0,timer;
  const go=n=>{const prev=items[i];i=(n+items.length)%items.length;items.forEach((el,k)=>{el.classList.remove("out");el.classList.toggle("on",k===i);el.setAttribute("aria-hidden",k!==i);});if(prev!==items[i])prev.classList.add("out");dots.forEach((d,k)=>d.setAttribute("aria-selected",k===i));};
  const start=()=>{clearInterval(timer);timer=setInterval(()=>go(i+1),4200);};
  dots.forEach((d,k)=>d.addEventListener("click",()=>{go(k);start();}));
  rot.addEventListener("mouseenter",()=>clearInterval(timer));rot.addEventListener("mouseleave",start);start();}
document.querySelectorAll(".ba").forEach(ba=>{
  const r=ba.querySelector("input"), set=v=>{ba.style.setProperty("--pos",v+"%");ba.querySelector(".ba-tag.l").style.opacity=v<14?0:1;ba.querySelector(".ba-tag.r").style.opacity=v>86?0:1;};
  let touched=false; r.addEventListener("input",()=>{touched=true;set(r.value);});
  if("IntersectionObserver" in window && !matchMedia("(prefers-reduced-motion: reduce)").matches){
    const io=new IntersectionObserver(([e])=>{ if(!e.isIntersecting||touched) return; io.disconnect();
      const keys=[[0,50],[500,30],[1100,70],[1600,50]], t0=performance.now();
      const step=now=>{ if(touched) return; const t=now-t0; let i=keys.findIndex(k=>k[0]>t); if(i===-1){set(50);r.value=50;return;}
        const [ta,va]=keys[i-1],[tb,vb]=keys[i], k=(t-ta)/(tb-ta), ease=k<.5?2*k*k:1-Math.pow(-2*k+2,2)/2, v=va+(vb-va)*ease; set(v); r.value=v; requestAnimationFrame(step); };
      setTimeout(()=>requestAnimationFrame(step),350);
    },{threshold:.5}); io.observe(ba);
  }
});
const TKM=(()=>{const root=document.getElementById("tkmenu");if(!root)return null;
  const panel=root.querySelector(".tkm-panel"),btns=$$("[data-menu]");let last=null;
  const open=()=>{last=document.activeElement;root.classList.add("open");root.setAttribute("aria-hidden","false");btns.forEach(b=>b.setAttribute("aria-expanded","true"));document.documentElement.style.overflow="hidden";setTimeout(()=>root.querySelector(".tkm-close").focus(),50);};
  const close=()=>{root.classList.remove("open");root.setAttribute("aria-hidden","true");btns.forEach(b=>b.setAttribute("aria-expanded","false"));document.documentElement.style.overflow="";if(last&&last.focus)last.focus();};
  btns.forEach(b=>b.addEventListener("click",open));
  root.addEventListener("click",e=>{if(e.target.closest("[data-mclose]"))close();if(e.target.closest("[data-mlink]"))close();});
  root.addEventListener("keydown",e=>{if(e.key==="Escape")close();if(e.key==="Tab"){const f=[...panel.querySelectorAll("a[href],button")];const a=f[0],z=f[f.length-1];if(e.shiftKey&&document.activeElement===a){e.preventDefault();z.focus();}else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus();}}});
  return {open,close};})();
render();
